<template>
  <label :class="['ms-checkbox', { 'event-none': readOnly }]">
    <input
      type="checkbox"
      class="ms-checkbox-control"
      :readOnly="readOnly"
      :checked="isChecked"
      :value="isChecked"
      :disabled="disabled"
      v-on="listeners"
    />
    <!-- <span :class="['checkmark', { 'event-none': readOnly }]"></span> -->
    <span v-if="label && isShowLabel" class="ms-checkbox--text">{{
      label
    }}</span>
  </label>
</template>
<script>
import { defineComponent, computed, watch } from 'vue';
export default defineComponent({
  name: 'msCheckbox',
  props: {
    modelValue: {
      default: false,
      type: [Boolean, Number],
    },
    label: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    isShowLabel: {
      // có hiển thị label ko?
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    //Variable
    let focused = false;

    //Method
    const onFocus = () => {
      focused = true;
    };
    const onBlur = () => {
      focused = false;
    };

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = (e) => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    // Event
    const listeners = computed(() => {
      return {
        click: (event) => {
          // emit('click', event);
        },
        input: () => {
          emit('update:modelValue', !props.modelValue);
        },
        change: (event) => {
          cancelEvent(event);
          emit('change', props.modelValue, props.label);
        },
        focus: (event) => {
          onFocus(event);
        },
        blur: (event) => {
          onBlur(event);
        },
      };
    });
    const isChecked = computed(() => props.modelValue || props.checked);

    return {
      focused,
      onFocus,
      onBlur,
      listeners,
      isChecked,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
